declare let process: {
    env: {
        REACT_APP_BASE_URL: string;
        REACT_APP_TOKEN_KEY: string;
        REACT_APP_SBX_SERVER: string;
    };
};

export default {
    baseUrl: process.env.REACT_APP_BASE_URL,
    sbxServer: process.env.REACT_APP_SBX_SERVER ?? '/sbx-server',
    token_key: process.env.REACT_APP_TOKEN_KEY ?? 'crm_token',
};
